import { render } from "./Legal.vue?vue&type=template&id=31149abd&scoped=true"
const script = {}

import "./Legal.vue?vue&type=style&index=0&id=31149abd&scoped=true&lang=scss"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31149abd"]])

export default __exports__